//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppLink from './AppLink'
import Card from './Card'

export default {
    components: {
    AppLink,
    },
    props: [
    'content'
    ],  
    methods: {
    scrubLink(link) {
        return link.replace('pages/', '')
    },
    }
}
